var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSmileyBad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 74,
    viewBox: "0 0 60 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30.9375,
    r: 30,
    fill: "#D792DF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7692 28.6301C22.6809 28.6301 24.2307 27.0803 24.2307 25.1686C24.2307 23.2568 22.6809 21.707 20.7692 21.707C18.8574 21.707 17.3076 23.2568 17.3076 25.1686C17.3076 27.0803 18.8574 28.6301 20.7692 28.6301ZM39.2307 28.6301C41.1424 28.6301 42.6922 27.0803 42.6922 25.1686C42.6922 23.2568 41.1424 21.707 39.2307 21.707C37.3189 21.707 35.7692 23.2568 35.7692 25.1686C35.7692 27.0803 37.3189 28.6301 39.2307 28.6301Z",
    fill: "#081731"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_972_3778)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3446 45.4149C40.4824 45.829 41.7404 45.2424 42.1546 44.1046C42.5687 42.9669 41.982 41.7088 40.8443 41.2947C39.7065 40.8806 38.4485 41.4673 38.0344 42.605C37.6203 43.7428 38.2069 45.0008 39.3446 45.4149Z",
    fill: "#E7CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3505 39.2938C36.4883 39.7079 37.7463 39.1213 38.1604 37.9836C38.5745 36.8458 37.9879 35.5878 36.8501 35.1736C35.7124 34.7595 34.4543 35.3462 34.0402 36.4839C33.6261 37.6217 34.2127 38.8797 35.3505 39.2938Z",
    fill: "#E7CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3564 35.9208C31.4941 36.3349 32.7522 35.7483 33.1663 34.6105C33.5804 33.4727 32.9938 32.2147 31.856 31.8006C30.7182 31.3865 29.4602 31.9731 29.0461 33.1109C28.632 34.2486 29.2186 35.5067 30.3564 35.9208Z",
    fill: "#E7CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8632 36.6688C25.001 37.0829 26.259 36.4963 26.6731 35.3586C27.0872 34.2208 26.5006 32.9628 25.3628 32.5486C24.2251 32.1345 22.967 32.7212 22.5529 33.8589C22.1388 34.9967 22.7254 36.2547 23.8632 36.6688Z",
    fill: "#E7CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.034 42.6045L34.7848 51.5316C34.6468 51.9106 34.2272 52.1063 33.8481 51.9683C33.4691 51.8304 33.2734 51.4108 33.4114 51.0317L38.1602 37.9844L34.04 36.4848L29.7911 48.1587C29.6531 48.5377 29.2335 48.7334 28.8544 48.5954C28.4754 48.4575 28.2797 48.0379 28.4177 47.6588L33.1665 34.6115L29.0463 33.1119L24.2975 46.1592C24.1595 46.5382 23.7399 46.7339 23.3608 46.5959C22.9818 46.458 22.7861 46.0384 22.9241 45.6593L26.6731 35.3588L22.5529 33.8592L16.3045 51.0267L14.9085 46.2087C14.5469 44.6384 13.0936 43.6273 11.6503 43.9263C10.2051 44.2433 9.32308 45.7607 9.67524 47.3229C9.67524 47.3229 11.6899 55.7442 12.5439 59.3461C13.3979 62.948 15.6677 66.3482 21.4593 68.4562C31.0483 71.9463 34.602 64.8534 35.4058 62.645C36.2096 60.4366 42.1542 44.1041 42.1542 44.1041L38.034 42.6045Z",
    fill: "#E7CB6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_972_3778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(12.9971 24.9375) rotate(20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmileyBad);
export default __webpack_public_path__ + "static/media/ic-smiley-bad.17193ff6d9bff5d89cdf99a6bb255da1.svg";
export { ForwardRef as ReactComponent };